var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"main",class:[_vm.b(),_vm.className],style:(_vm.styleSizeName)},[_c('i',{staticClass:"el-icon-message"})])
}
var staticRenderFns = []

export { render, staticRenderFns }